import React from 'react';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider, { Settings as SlickTypes } from 'react-slick';
import styled from '@emotion/styled';

const StyledSlider = styled(Slider)`
  .slick-dots {
    bottom: -80px;
  }

  @media (max-width: 834px) {
    .slick-dots {
      bottom: -40px;
    }
  }

  .slick-dots li {
    width: 30px;
  }

  .slick-dots li button:before {
    font-size: 10px;
    opacity: 1;
    color: #ffffff;
  }

  .slick-dots li.slick-active button:before {
    color: #2277d1;
  }
`;

interface Props extends SlickTypes {
  children: React.ReactNode;
}

const SlickSliderContainer = React.forwardRef(
  (props: Props, ref: React.Ref<Slider> | undefined) => {
    const { children, ...restProps } = props;
    return (
      <StyledSlider ref={ref} {...restProps}>
        {children}
      </StyledSlider>
    );
  },
);

export default SlickSliderContainer;
